<p>Authorizing user and redirecting to app &hellip;</p>
